export default "__VITE_ASSET__Co7Qw248__"